import { balanceAccountName } from './balanceNaming';

export const novigAccounts = [
  { id: '50b001ba-8ec7-49df-b269-87ce345a0a7c', slug: 'main-wallet', platform: 'NoVig', owner: 'DK', strategy: 'Main Wallet', role: 'main' },
  { id: '7bec7419-e4cc-484e-a75d-cd4faf925861', slug: 'copytrader', platform: 'NoVig', owner: 'DK', strategy: 'Fido CT', role: 'copytraders' },
  { id: 'eaed31bf-bb25-480f-8449-a68544bf120a', slug: 'mm', platform: 'NoVig', owner: 'DK', strategy: 'MM', role: 'market-makers' },
  { id: '38409d22-b566-44db-9582-fb1d4c8216ed', slug: 'mm-live', platform: 'NoVig', owner: 'DK', strategy: 'MM LIVE', role: 'market-makers' },
].map(account => ({ ...account, name: balanceAccountName(account) }));

export const antNovigAccounts = [
  { id: 'b5447932-bd9a-4b58-b144-905216046801', slug: 'main-wallet', platform: 'NoVig', owner: 'Anthony', strategy: 'Main Wallet', role: 'main' },
  { id: 'e8a4f453-aba2-4e88-b7db-0f11e1d0fff1', slug: 'arb', platform: 'NoVig', owner: 'Anthony', strategy: 'ARB', role: 'arbitrage' },
  { id: '646514ca-62c2-4c1f-a74f-9cd793da21d5', slug: 'matt-ct', platform: 'NoVig', owner: 'Anthony', strategy: 'Matt CT', role: 'copytraders' },
].map(account => ({ ...account, name: balanceAccountName(account) }));
